import { COOKIE_SAVINGS_ACCOUNT_SEARCH } from '@/constants/cookies';
import { getSavingsAccountSearch } from '@/graphql/queries/banking/savings-account';
import { getProviderWithSavingsAccounts } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/banking/savings-accounts';

export default async ({ $apolloQuery, app, $cookies, redirect, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const code = $cookies.get(COOKIE_SAVINGS_ACCOUNT_SEARCH);
  const defaultSearch = () => store.commit('search/reset', { type: 'saving' });
  const slug = route.params.provider;
  await $apolloQuery(getProviderWithSavingsAccounts, { slug }).then(provider => {
    const description = store.$i18n.t('provider.description', { provider: provider.name });
    const title = store.$i18n.t('provider.title', { provider: provider.name });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'], ['i18n/banking', '/money/'], ['i18n/savings', '/compare-savings-accounts/'],
      ['i18n/providers', '/compare-savings-accounts/providers/', 'mobile'], provider.name
    ]);
    store.commit('jumbotron/SET_JUMBOTRON', { title, type: 'generic' });
    store.commit('pageContent/setHead', { description, title });
    store.commit('products/setList', provider.savings_accounts);
    delete provider.savings_accounts;
    store.commit('providers/set', provider);
  }).catch(e => console.error(e)); // redirect(302, app.localePath('/compare-savings-accounts/')));
  if (!code) return defaultSearch();
  await $apolloQuery(getSavingsAccountSearch, { code }).then(search => store.commit('search/set', search)).catch(defaultSearch);
};
